import axios from 'axios'
import { config } from '../Config/config'


const custRelationService = {
    
    getAll: (filter) => {
        // getAll: () => {
        const result = axios.post(config.apiUrl + '/customerRelationFilter', filter)
            // const result = axios.get(config.apiUrl + '/customerRelation')
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    addData: (data) => {
        const result = axios.post(config.apiUrl + '/customerRelation', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editData: (data) => {
        const result = axios.put(config.apiUrl + '/customerRelation', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    editDataDelete: (data) => {
        const result = axios.put(config.apiUrl + '/customerDelete', data)
            // const result = axios.post(config.apiUrl+'/categoryById/60249f62c79df0c78d032ab5', data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result

    },

    getById: (id) => {
        const result = axios.get(config.apiUrl + '/customerRelationById/' + id)
            //(+ id) => memanggil parameter
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    // getByCategoryId: (id) => {
    //     const result = axios.get(config.apiUrl + '/customerRelationByCategoryId/' + id)

    //         .then(respon => {
    //             return {
    //                 success: respon.data.success,
    //                 result: respon.data.result
    //             }
    //         })
    //         .catch(error => {
    //             return {
    //                 success: false,
    //                 error: error
    //             }
    //         })
    //     return result
    // },

    // deleteData
    deleteData: (id) => {
        // deleteData: (data) => {
        const result = axios.delete(config.apiUrl + '/customerRelation/' + id)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    },

    cekRelasiByName: (data) => {
        const result = axios.get(config.apiUrl + '/cekRelasiByName/'+ data)
        // const result = axios.post(config.apiUrl + '/cekUserByEmail'+ data)
            .then(respon => {
                return {
                    success: respon.data.success,
                    result: respon.data.result[0]
                }
            })
            .catch(error => {
                return {
                    success: false,
                    error: error
                }
            })
        return result
    }

}

export default custRelationService
